/**
 * Escapes a value for interpolation into an HTML string (tooltips built with
 * `innerHTML`, the waybill handed to `iframe.srcdoc`, …). Anything that comes
 * from the database — truck, driver, organization, org settings — goes through
 * this before it reaches such a template.
 */
export function escapeHtml(unsafe?: string): string {
  if (!unsafe) return "";
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
